import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ApplicationStateService } from '../../services/application-state/application-state.service';

export const ApplicationStateInitializerResolver = (
    route: ActivatedRouteSnapshot,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    state: RouterStateSnapshot,
) => {
    const applicationStateService = inject(ApplicationStateService);
    const applicationId = route?.paramMap.get('id');

    if (!applicationId) {
        /**
         * If the Application ID is not present in the route, this means that the application state
         * should be cleared and not displayed since there is no application to display the state for.
         * This is the case when the user attempts to create a new application in the pre-application form steps.
         */
        applicationStateService.clearApplicationState();
        return;
    }
};
